/**
 * Simple markdown parser utility for teacher-facing text.
 * Removes raw markdown symbols and renders clean HTML.
 */

/**
 * Parse markdown text to plain formatted text (removing raw symbols)
 * @param {string} text - Raw markdown text
 * @returns {string} - Clean text without markdown symbols
 */
export function stripMarkdown(text) {
  if (!text) return "";
  
  let result = text;
  
  // Remove markdown heading markers (##, ###, etc.)
  result = result.replace(/^#{1,6}\s+/gm, "");
  
  // Remove bold/italic markers (**text** or __text__)
  result = result.replace(/\*\*([^*]+)\*\*/g, "$1");
  result = result.replace(/__([^_]+)__/g, "$1");
  
  // Remove single asterisk/underscore (italic)
  result = result.replace(/\*([^*]+)\*/g, "$1");
  result = result.replace(/_([^_]+)_/g, "$1");
  
  // Remove horizontal rules (---, ___, ***)
  result = result.replace(/^[-_*]{3,}$/gm, "");
  
  // Remove extra blank lines
  result = result.replace(/\n{3,}/g, "\n\n");
  
  return result.trim();
}

/**
 * Format markdown for teacher display - preserves structure but removes symbols
 * @param {string} text - Raw markdown text
 * @returns {string} - Formatted text with preserved line breaks
 */
export function formatTeacherText(text) {
  if (!text) return "";
  
  // First strip markdown symbols
  let formatted = stripMarkdown(text);
  
  // Preserve line breaks for display
  return formatted;
}
